import {
  BulbOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  MailOutlined,
  StopOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button, Popconfirm, Tag, Tooltip } from "antd";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePlayers,
  editTeamPlayers,
} from "../../../store/actions/team.actions";
import { DeletePopConfirmContent } from "./PlayerTable";

export const SelectedItemsControl = ({
  selected,
  validation,
  clearSelection,
  handleSendWelcomeEmail,
  canEditPlayer,
  canDeletePlayer,
  canSendWelcomeEmail,
}) => {
  const dispatch = useDispatch();

  const disabled = useMemo(() => !selected.length, [selected]);

  const selectedIds = useMemo(
    () => selected.map(({ player_id }) => player_id),
    [selected]
  );

  const isAllInvalid = selected.every(({ valid }) => !valid);

  const tooltipTitle = disabled ? "Select players first" : undefined;

  const handleDeleteSelected = async () => {
    await dispatch(deletePlayers(selectedIds));
    clearSelection();
  };

  const handleActivateSelected = async () => {
    await dispatch(
      editTeamPlayers(
        selected
          .filter(({ valid }) => valid)
          .map(({ player_id, first_name, last_name, number }) => ({
            retired: false,
            player_id,
            first_name,
            last_name,
            number
          }))
      )
    );
  };

  const handleInactivateSelected = async () => {
    await dispatch(
      editTeamPlayers(
        selected.map(({ player_id }) => ({ retired: true, player_id }))
      )
    );
  };

  const handleSendEmailToSelected = async () => {
    const filtered = selected.filter(({ email }) => email);
    await Promise.all(
      filtered.map((player) => handleSendWelcomeEmail(player)())
    );
  };

  return (
    <div
      style={{
        margin: "16px 0",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          padding: "0px 16px",
          display: "flex",
          gap: 16,
          alignItems: "center",
        }}
      >
        {!!selected.length && (
          <div style={{ fontSize: 15, fontWeight: "bold" }}>
            {selected.length} players selected
          </div>
        )}
        <Popconfirm
          placement="left"
          title={DeletePopConfirmContent}
          okText="Yes"
          cancelText="No"
          onConfirm={handleDeleteSelected}
          disabled={disabled || !canDeletePlayer}
        >
          <Tooltip title={!canDeletePlayer ? "" : (disabled ? "Select players first" : undefined)}>
            <Button
              danger
              type="primary"
              disabled={disabled || !canDeletePlayer}
              style={{ display: "flex", alignItems: "center" }}
            >
              Delete
            </Button>
          </Tooltip>
        </Popconfirm>
        <Tooltip
          title={
            tooltipTitle ||
            (isAllInvalid &&
              "Please fix the player details before setting them to active")
          }
        >
          <Button
            type="primary"
            disabled={disabled || isAllInvalid || !canEditPlayer}
            onClick={handleActivateSelected}
            style={{ display: "flex", alignItems: "center" }}
          >
            Set to active
          </Button>
        </Tooltip>
        <Tooltip
          title={
            tooltipTitle ||
            (isAllInvalid &&
              "Please fix the player details before setting them to inactive")
          }
        >
          <Button
            ghost
            danger
            disabled={disabled || isAllInvalid || !canEditPlayer}
            onClick={handleInactivateSelected}
            style={{ display: "flex", alignItems: "center" }}
          >
            Set to inactive
          </Button>
        </Tooltip>
        <Tooltip
          title={
            !canSendWelcomeEmail ? "" : (
              tooltipTitle ||
              (
                isAllInvalid &&
                "Please fix the player details before sending welcome emails"
              )
            )
          }
        >
          <Button
            disabled={disabled || isAllInvalid || !canSendWelcomeEmail}
            onClick={handleSendEmailToSelected}
            style={{ display: "flex", alignItems: "center" }}
          >
            Send welcome email
          </Button>
        </Tooltip>
      </div>
      <div style={{ display: "flex" }}>
        <Tooltip title="Valid players">
          <Tag
            icon={<CheckCircleOutlined />}
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 15,
              padding: "4px 8px",
            }}
            color="green"
          >
            {validation?.valid || 0}
          </Tag>
        </Tooltip>
        <Tooltip title="Invalid players">
          <Tag
            icon={<CloseCircleOutlined />}
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 15,
              padding: "4px 8px",
            }}
            color="error"
          >
            {validation?.error || 0}
          </Tag>
        </Tooltip>
      </div>
    </div>
  );
};
